const text = (value) => String(value ?? "").trim();

export const getBookerCompany = (record) =>
  record?.booker_company || record?.group?.booker_company ||
  record?.reservation_group?.booker_company || record?.check_in_readiness?.booker_company || null;

export const isCompanyBooker = (record) => Boolean(
  record?.booker_company_id || record?.group?.booker_company_id ||
  record?.reservation_group?.booker_company_id || getBookerCompany(record)
);

export const getCompanyName = (company) => text(company?.name) || text(company?.legal_name);

export const getBookerContactName = (record) => text(
  record?.booker_contact_name ?? record?.group?.booker_contact_name ??
  record?.reservation_group?.booker_contact_name ?? record?.check_in_readiness?.booker_contact_name
);

export const getPersonName = (person) =>
  [person?.first_name, person?.last_name].map(text).filter(Boolean).join(" ") ||
  text(person?.full_name) || text(person?.name);

export const getBookerDisplayName = (record) => {
  if (isCompanyBooker(record)) return getCompanyName(getBookerCompany(record)) || text(record?.booker_name);
  return getPersonName(record?.booker || record?.group?.booker || record?.reservation_group?.booker) ||
    text(record?.booker_name);
};

export const requiresCompanyBookerContact = (settings) =>
  ![false, "false", 0, "0"].includes(settings?.require_company_booker_contact);

export const getReservationCustomerName = (reservation) => {
  const guests = Array.isArray(reservation?.guests) ? reservation.guests : [];
  const mainGuest = guests.find((guest) => guest?.is_main_guest);
  const mainName = getPersonName(mainGuest?.customer || reservation?.main_guest);
  if (mainName) return mainName;
  if (isCompanyBooker(reservation)) return getBookerDisplayName(reservation);
  const person = guests.find((guest) => guest?.is_booker) || guests[0];
  return getPersonName(person?.customer) || getBookerDisplayName(reservation);
};
